import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const EMPTY_INTERMEDIARY = {
  companyName: '',
  cui: '',
  jNumber: '',
  address: '',
  phone: '',
  email: '',
  website: '',
  anpcNumber: '',
  representative: '',
  logoUrl: null
};

// Preia datele firmei brokerului logat pentru precompletarea documentelor (FEIS, Ofertă)
export const fetchIntermediaryData = async () => {
  const token = localStorage.getItem('token');
  const { data } = await axios.get(`${API_URL}/api/broker/profile`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return {
    companyName: data.companyName || 'Intermediar de Credite',
    cui: data.cui || '',
    jNumber: data.jNumber || '',
    address: data.address || '',
    phone: data.phone || '',
    email: data.email || '',
    website: data.website || '',
    anpcNumber: data.anpcNumber || '',
    representative: data.representative || '',
    logoUrl: data.logoUrl || null
  };
};
